var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-list"},[_vm._l((_vm.courses),function(item){return _c('Course',{key:item.courseId,attrs:{"data":item}})}),(!_vm.courses.length)?_c('div',{staticClass:"course-none"},[_c('Divider',[_vm._v("您还没有可以参加考试的课程")])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }